<template>
    <div class="suggestive-search-box" v-if="options">

        <div class="box-search">
            <div class="ele-search2 w-100">
                <i class="fa fa-search"></i>
                <input type="text" class="ele-search2-input" 
                    :name="name"
                    @focus="showOptions()"
                    @blur="exit()"
                    @keyup="keyMonitor"
                    v-model="searchFilter" 
                    placeholder="โปรดเลือกคู่ค้า"/>
            </div>
        </div>
        <div class="suggestions" v-show="optionsShown">
            <div class="suggestion" @mousedown="selectOption(option)" v-for="(option, index) in filteredOptions" :key="index">
                <p> {{ option.name || option.id || '-' }} </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                selected: {},
                optionsShown: false,
                searchFilter: '',
                options: []
            }
        },
        watch: {
            searchFilter() {
                if (this.filteredOptions.length === 0) {
                    this.selected = {};
                } else {
                    this.selected = this.filteredOptions[0];
                }
                this.$emit('filter', this.searchFilter);
            }
        },
        computed: {
            filteredOptions() {
                const filtered = [];
                const regOption = new RegExp(this.searchFilter, 'ig');
                for (const option of this.options) {
                    if (option.name && option.name.match(regOption)){
                        filtered.push(option);
                    }
                }
                return filtered;
            }
        },
        mounted() {
            axios.get('/admin/member/autocomplete', {
                params: {
                    term: this.searchStr,
                }
            }).then(({ data }) => {
                this.options = data;
            });
        },
        methods: {
            selectOption(option) {
                this.selected = option;
                this.optionsShown = false;
                this.searchFilter = this.selected.name;
                this.$emit('selected', this.selected);
            },
            showOptions(){
                this.searchFilter = '';
                this.optionsShown = true;
            },
            exit() {
                if (!this.selected.id) {
                    this.selected = {};
                    this.searchFilter = '';
                } else {
                    this.searchFilter = this.selected.name;
                }
                this.optionsShown = false;
            },
            // Selecting when pressing Enter
            keyMonitor: function(event) {
                if (event.key === "Enter" && this.filteredOptions[0])
                this.selectOption(this.filteredOptions[0]);
            }
        },
        props: {
            name: {
                type: String,
                required: false,
                default: 'dropdown',
                note: 'Input name'
            },
        },
    }
</script>

<style lang="scss" scoped>

.suggestive-search-box {
    position: relative;
    .suggestions {
        z-index: 3;
        position: absolute;
        left: 0;
        right: 0;
        border: 1px solid #eee;
        background-color: #ffffff;
        box-shadow: 0px 3px 16px 0px rgba(0,0,0,0.25);
        max-height: 400px;
        overflow-x: scroll;
        .suggestion {
            padding: 8px 14px;
            border-top: 1px solid #eee;
            position: relative;
            cursor: pointer;
            p {
                font-family: "Tahoma";
                font-size: 14px;
                margin-bottom:0px;
            }
            &:hover {
                background-color: #e7ecf5;
            }
        }
    }
}
</style>
